import apiClient from './client';

export const facultyService = {
    /**
     * Fetch all faculty members.
     */
    getAllFaculty: async () => {
        return apiClient('/faculty', {
            method: 'GET'
        });
    },

    /**
     * Extract skills from a bio using AI.
     * Does NOT save to database.
     */
    extractSkills: async (aboutText) => {
        return apiClient('/faculty', {
            method: 'POST',
            body: {
                action: 'extract',
                about: aboutText
            }
        });
    },

    /**
     * Create or update a faculty member with provided skills.
     */
    saveFaculty: async (facultyData) => {
        return apiClient('/faculty', {
            method: 'POST',
            body: {
                ...facultyData,
                action: 'save'
            }
        });
    },

    /**
     * Delete a faculty member.
     */
    deleteFaculty: async (facultyId) => {
        return apiClient(`/faculty?facultyId=${facultyId}`, {
            method: 'DELETE'
        });
    }
};
